import React, { useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FiChevronLeft } from 'react-icons/fi';
import { congresosAnterioresData } from '../datosCongresos';
import '../styles/DetalleCongreso.css';

import imgCongresoDefault from '../assets/images/congreso4.jpg';
import portadaImg from '../assets/images/portada.webp'; // Fondo para parallax

const DetalleCongreso = () => {
  const { congresoId } = useParams();
  const congreso = congresosAnterioresData.find(c => c.id === congresoId);

  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [congresoId]);

  if (!congreso) {
    return (
      <div className="detalle-congreso-page">
          <div className="detalle-congreso-container not-found">
            <h2>Congreso no encontrado</h2>
            <p>El congreso que buscas no existe o ha sido movido.</p>
            <Link to="/congreso#congresos-anteriores" className="back-link">
              <FiChevronLeft /> Volver a la lista de Congresos
            </Link>
          </div>
      </div>
    );
  }

  return (
    <div className="detalle-congreso-page" ref={containerRef}>
      <motion.div
        className="detalle-congreso-background"
        style={{ 
          backgroundImage: `url(${portadaImg})`,
          y: parallaxY
        }}
      />
      <motion.div
        className="detalle-congreso-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <header className="detalle-congreso-header">
          <h1 className="detalle-congreso-title">{congreso.title}</h1>
          {congreso.lema && <h3 className="detalle-congreso-lema">"{congreso.lema}"</h3>}
        </header>
        
        <main className="detalle-congreso-main">
          <div className="media-container">
            {congreso.youtubeVideoId ? (
              <div className="video-responsive-wrapper">
                <iframe
                  src={`https://www.youtube.com/embed/${congreso.youtubeVideoId}`}
                  title={congreso.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            ) : (
              <img src={imgCongresoDefault} alt="Imagen del congreso" className="featured-image" />
            )}
          </div>

          <article className="detalle-congreso-content">
            <p>{congreso.descripcion}</p>
          </article>
        </main>

        <footer className="detalle-congreso-footer">
          <Link to="/congreso#congresos-anteriores" className="back-link">
            <FiChevronLeft /> Volver a todos los Congresos
          </Link>
        </footer>
      </motion.div>
    </div>
  );
};

export default DetalleCongreso;